import "./Contact.css";

const Contact = () => {
    return (
        <div className="contact" id="contact">
            <div className="container py-5">
                {/* Componente de contacto sin las banderas grandes */}
            </div>
        </div>
    );
};

export default Contact;

